module.exports = __webpack_public_path__ + "img/saimage2.374233f0.jpg";